// extracted by mini-css-extract-plugin
export default {"header":"MainPage_header__cf8ci","search":"MainPage_search__+pnCW","banner":"MainPage_banner__o+7vt","direct":"MainPage_direct__ItEng","item":"MainPage_item__aMU6Z"};